import { TAG_VARIANTS } from '@components/tag';

import { ACTION_TYPE, TravellerJourneyActionRunStatus } from 'api/types';

import { t } from './locale';

export type TravellerStatus = 'not_started' | 'in_progress' | 'completed' | 'paused';

export const statusLabelMap: Record<TravellerStatus, string> = {
  in_progress: t('inProgress'),
  completed: t('completed'),
  not_started: t('notStarted'),
  paused: t('paused'),
};

export const actionStatusLabelMap: Record<TravellerJourneyActionRunStatus, string> = {
  in_progress: t('action_status_in_progress'),
  completed: t('action_status_completed'),
  halted: t('action_status_halted'),
  skipped: t('action_status_skipped'),
  upcoming: t('action_status_upcoming'),
  waiting_to_be_started: t('action_status_waiting_to_be_started'),
};

export const statusTagMap: Record<
  TravellerStatus | TravellerJourneyActionRunStatus,
  (typeof TAG_VARIANTS)[number]
> = {
  not_started: 'empty',
  in_progress: 'orange',
  completed: 'green',
  paused: 'purple',
  halted: 'green',
  skipped: 'gray',
  upcoming: 'purple',
  waiting_to_be_started: 'indigo',
};

// Excluded from the traveller journeys table columns and filters.
export const excludedActionTypes: Array<ACTION_TYPE> = [
  'branch_base',
  'break_loop',
  'ghost',
  'journey_branch',
  'journey_loop',
  'journey_start',
  'placeholder',
];

export const actionStatusValues: Array<{ value: TravellerJourneyActionRunStatus; label: string }> =
  [
    { value: 'in_progress', label: t('action_status_in_progress') },
    { value: 'completed', label: t('action_status_completed') },
    { value: 'halted', label: t('action_status_halted') },
    { value: 'skipped', label: t('action_status_skipped') },
    { value: 'upcoming', label: t('action_status_upcoming') },
    { value: 'waiting_to_be_started', label: t('action_status_waiting_to_be_started') },
  ];
